import {
  selectDepartureRoute,
  selectIsCommercial
} from '../ferryRouteSelections/selectors'
import { createSelector } from 'reselect'
import { selectAvailableVehicleOptions } from '../configuration/selectors'

const selectRouteVehicleOptions = createSelector(
  selectAvailableVehicleOptions,
  selectDepartureRoute,
  selectIsCommercial,
  (vehicleOptions, departureRoute, isCommercial) => {
    if (!vehicleOptions) return null
    const { groups, vehicles } = vehicleOptions
    if (departureRoute?.vehicleTypes) {
      let routeTypeCodes = departureRoute?.vehicleTypes?.map(
        vt => vt.resourceCode
      )
      if (isCommercial) {
        routeTypeCodes = routeTypeCodes.filter(code => code === 'TT')
      } else {
        routeTypeCodes = routeTypeCodes.filter(code => code !== 'TT')
      }
      return {
        groups,
        vehicles: vehicles.filter(v => routeTypeCodes.includes(v.resourceCode))
      }
    } else {
      return vehicleOptions
    }
  }
)

export default selectRouteVehicleOptions
